var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61.337 209.949-19.805-24.333c-25.279-31.058-20.594-76.728 10.463-102.006 31.058-25.279 76.727-20.594 102.006 10.464l2.129 2.616-4.289 86.149z",
    fill: "#f1f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.601 211.011 20.868-25.396c25.278-31.057 20.594-76.727-10.464-102.005-31.058-25.279-76.727-20.594-102.006 10.464l-2.128 2.614-11.179 82.816z",
    fill: "#e1daf8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m341.84 425.454 28.927 67.055c5.103 11.83 16.752 19.491 29.635 19.491 23.204 0 38.827-23.754 29.635-45.06l-17.897-41.486z",
    fill: "#453d83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.659 425.454-28.927 67.055c-5.103 11.83-16.752 19.491-29.635 19.491-23.204 0-38.827-23.754-29.635-45.06l17.897-41.486z",
    fill: "#5f55af"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m290.907 80.747v-45.84c0-19.279-15.628-34.907-34.907-34.907-19.279 0-34.907 15.628-34.907 34.907v45.84z",
    fill: "#5f55af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0v80.747h34.907v-45.84c0-19.279-15.628-34.907-34.907-34.907z",
    fill: "#453d83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 281.042,
    fill: "#6ba7ff",
    r: 211.308
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 69.734v422.616c116.516 0 211.308-94.792 211.308-211.308s-94.792-211.308-211.308-211.308z",
    fill: "#5e69e2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 281.042,
    fill: "#f1f1fb",
    r: 141.007
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 140.035v282.014c77.751 0 141.007-63.255 141.007-141.007 0-77.751-63.256-141.007-141.007-141.007z",
    fill: "#e1daf8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m297.819 237.767c-5.857-5.857-15.355-5.857-21.213 0l-20.606 20.606-20.606-20.606c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l31.213 31.213c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.465 10.606-4.393l31.213-31.213c5.858-5.858 5.858-15.356 0-21.213z",
    fill: "#5f55af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.819 237.767c-5.857-5.857-15.355-5.857-21.213 0l-20.606 20.606v36.213c3.839 0 7.678-1.465 10.606-4.393l31.213-31.213c5.858-5.858 5.858-15.356 0-21.213z",
    fill: "#453d83"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicTime);
export default __webpack_public_path__ + "static/media/basicTime.3661805b070c0b08ca47f76de3b754e2.svg";
export { ForwardRef as ReactComponent };